import Loader from "components/common/Loader";
import React, { useEffect } from "react";
import {
  fetchRecommendedEvents,
  selectRecommendedEvents,
} from "store/event/recommendedEvents.slice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import NoEventsPlaceholder from "../NoEventsPlaceholder";
import RecommendedEventCard from "../RecommendedEventCard";
import * as S from "./index.styles";

const RecommendedEventsSection: React.FC = () => {
  const dispatch = useAppDispatch();
  const { data, isLoading, error } = useAppSelector(selectRecommendedEvents);

  useEffect(() => {
    dispatch(fetchRecommendedEvents());
  }, [dispatch]);

  return (
    <S.RecommendedSection>
      <S.RecommendedSectionTitle>Recommended For You</S.RecommendedSectionTitle>
      {error && <p style={{ margin: "1rem" }}>No recommended events found</p>}
      <S.RecommendedCarousel>
        {isLoading ? (
          <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Loader message="Loading recommended events..." />
          </div>
        ) : data.length > 0 ? (
          data.map((item, key) => (
            <RecommendedEventCard
              key={key}
              id={item.id}
              image_url={item.image_url}
              activity_title={item.activity_title}
              activity_description={item.activity_description}
            />
          ))
        ) : (
          <div style={{ justifyContent: "center" }}>
            <NoEventsPlaceholder />
          </div>
        )}
      </S.RecommendedCarousel>
    </S.RecommendedSection>
  );
};

export default RecommendedEventsSection;
